import {
  UseMutationResult,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'
import { updateDefaultVisualization } from '~map-preview/api/updateDefaultVisualization'
import { useMapId } from '~map-preview/states/map'
import { MutationUpdateDefaultVisualizationArgs } from '~map-preview/types/__generated/gql/graphql'

const useUpdateDefaultVisualization = () => {
  const mapId = useMapId()
  const query = useQueryClient()

  const mutation = useMutation({
    mutationFn: async (variables: MutationUpdateDefaultVisualizationArgs) => {
      return updateDefaultVisualization({ ...variables, id: mapId })
    },
    onSuccess: () => {
      query.invalidateQueries({
        queryKey: ['getMapById', mapId]
      })
    }
  })

  return mutation as UseMutationResult<unknown>
}

export { useUpdateDefaultVisualization }
